import {
  Button,
  Menu,
  Spinner,
  Select,
  Box,
  Form,
  FormField,
  TextInput,
  Layer,
  SelectMultiple,
  Text,
  DataTable
} from "grommet";
import React, { useEffect, useState } from "react";
// import "./OnlineFormList.css";
import searchIcon from "../../../../../assets/search.svg";
import view from "../../../../../assets/veiw.svg";
import { useStore } from "../../../../../Hooks/useStore";
import { observer } from "mobx-react";
import { useNavigate } from "react-router-dom";
import Pagination from "../../common/Pagination/Pagination";
import noResult from "../../../../../assets/no-result.png";
import CommonButton from "../../common/Button/CommonButton";
import closeAddUserSidebar from "../../../../../assets/close_small.svg";
import excelFileAddUser from "../../../../../assets/Microsoft excel.svg";
import './AddFitToFly.css';
import { FormTrash } from "grommet-icons";
import { DocumentUpload } from 'grommet-icons';
import usersService from "../../screens/IAM/Users/users.service";
import { APIs } from "../../../../../util/api/APIs";
import FormSubmit from "../../../../../services/form/formSubmit";
import { Storage } from 'aws-amplify';




const fittofly = observer(() => {
  const { rootStore } = useStore();
  const navigate = useNavigate();

  const [itemsPerPage] = useState(10);
  const [currentPage, setCurrentPage] = useState(1);
  const [originalFormList, setOriginalFormList] = useState([]);
  const [rootFormDataList, setRootFormDataList] = useState([]);
  const [searchString, setSearchString] = useState("");
  const [Fittofly, setFittofly] = useState(false);
  const [showftfform, setshowftfform] = useState(false);
  const [organization, setOrganization] = useState("");
  const [questions, setQuestions] = useState([{ id: 1, value: "" }]); // Track dynamic questions
  const [organizations, setOrganizations] = useState([]);
  const [FormData, setFormData] = useState([]);
  const [pdfFile, setPdfFile] = useState(null);
  const [uploadedPdfLink, setUploadedPdfLink] = useState("http.form.com");
  const [ftfformview, setftfformview] = useState("");
  const [selectedFile, setSelectedFile] = useState(null);

  // alert(JSON.stringify(ftfformview))


  const showftfScreening = async () => {
    try {
      const Data = await FormSubmit.showftfScreening();
      setFormData(Data.data);
    } catch (error) {
      console.error("Error fetching forms:", error);
    }
  };

  const organizationList = async () => {
    let organizations = await usersService.listOrganizations();
    rootStore.adminStore.handleUserOrganization(organizations);
  };
  useEffect(() => {
    organizationList();
    showftfScreening();
  }, []);



  // alert(JSON.stringify(organizationList))   



  const [selectedOrgId, setSelectedOrgId] = useState(null);
  const [searchText, setSearchText] = useState("");

  // console.log("dsfgdgddd", rootStore.adminStore.getUserOrganization);
  const filteredOptions = rootStore.adminStore.getUserOrganization.filter((org) =>
    org.name.toLowerCase().includes(searchText.toLowerCase())
  );

  const handleSelectChange = (event) => {
    const orgId = event.option.value; // Get the selected organization ID
    setSelectedOrgId(orgId); // Update state with the selected ID

    if (rootStore.adminStore.getRoleName.toLowerCase() !== "admin") {
      rootStore.adminStore.handleSelectedOrgId(orgId); // Update global state if needed
    }
  };

  // Generate random file name
  const generateRandomFileName = (originalFileName) => {
    const randomNumber = Math.floor(Math.random() * 1000000);  // Generate a random number (up to 6 digits)
    const fileName = originalFileName.replace(/\.[^/.]+$/, "");  // Remove the existing file extension
    return `${randomNumber}-${fileName}.pdf`;  // Concatenate random number and the file name with .pdf extension
  };

  const handlePdfUpload = async (event) => {
    const file = event.target.files[0];
    if (file) {
      setSelectedFile(file.name); // Store file name in state
    }

    if (file) {
      const originalFileName = file.name;  // Get the original file name
      const fileName = generateRandomFileName(originalFileName);  // Generate random file name
      const folderPath = `FitToFlyForms/${fileName}`;  // Save under FitToFlyForms folder
      const currentUrl = window.location.href;
      let region = 'us-east-2'; // Default region
      let bucket = 'skali-report';  // Default bucket

      // Check if the URL contains "localhost" or "sbx" to decide region
      if (currentUrl.includes('localhost') || currentUrl.includes('sbx')) {
        region = 'us-west-1';  // Set region to us-west-1 for localhost or sbx
        bucket = 'sbx-skali-report';
      }

      try {
        // Upload PDF to S3
        await Storage.put(folderPath, file, {
          bucket: bucket,
          region: region,
          contentType: 'application/pdf',
          progressCallback: (progress) => {
            console.log('Upload progress:', progress);
          },
        });
        console.log('PDF uploaded successfully');

        // Retrieve the URL of the uploaded file
        const fileUrl = await Storage.get(folderPath, {
          bucket: bucket,
          region: region,
          level: 'public', // Adjust access level if needed
          expires: 604799, // Set expiration if needed
        });

        // Save the uploaded file URL in state
        const messageContent = fileUrl.split('?')[0];
        setUploadedPdfLink(messageContent);
        console.log("Uploaded PDF URL:", messageContent);

      } catch (error) {
        console.error('Error uploading PDF:', error);
      }
    }
  };

  const handleSave = async () => {
    try {
      // Create the body data in the correct format

      const requestData = {
        orgId: selectedOrgId, // Dynamically use selectedOrgId from state
        formUrl: uploadedPdfLink,
        questions: questions.map((q) => q.value), // Extracting question values
      };

      // Send the POST request with the formatted data
      const response = await FormSubmit.ftfScreening(requestData.orgId, requestData.formUrl, requestData.questions);

      console.log("Form Data Saved:", response);

      if (response) {
        // Show success notification
        rootStore.notificationToastStore.showNotification("Questions Added successfully", false, 3000);

        // Close the form modal
        setFittofly(false); // Assuming this is the state controlling the popup
        showftfScreening();

        // Optional: If there is a global state update you want to trigger after saving
        // rootStore.someStore.updateSomeState(response.data);

      } else {
        console.error("Error saving form data:", response);
        rootStore.notificationToastStore.showNotification("Failed to save questions", true, 3000);
      }
    } catch (error) {
      console.error("Error saving form data:", error);

      let errorMessage = "An unexpected error occurred while saving the questions";
      if (error.response && error.response.data) {
        errorMessage = error.response.data.errorMessage || errorMessage;
      }

      // Show error notification if something goes wrong
      rootStore.notificationToastStore.showNotification(errorMessage, true, 3000);
    }
  };


  const showform = async (id) => {
    try {
      rootStore.loadingStore.setShowLoader(true);
      setshowftfform(true)
      const ftfformviewdata = await FormSubmit.showftfformbyuploadid(id);
      setftfformview(ftfformviewdata.data)
      rootStore.loadingStore.setShowLoader(false);
    } catch (error) {
      console.error("Error fetching forms:", error);
    }
  }





  // Filter the organizations based on search text


  const handleAddQuestion = () => {
    setQuestions([...questions, { id: questions.length + 1, value: "" }]);
  };

  const handleRemoveQuestion = (id) => {
    setQuestions(questions.filter((q) => q.id !== id));
  };

  const handleQuestionChange = (id, value) => {
    setQuestions(questions.map((q) => (q.id === id ? { ...q, value } : q)));
  };

  const onSearchStrChange = (value) => {
    setSearchString(value);
    if (value.trim() === "") {
      setRootFormDataList(originalFormList);
    }
  };

  const onSearch = (value) => {
    const lowerCaseValue = value.trim().toLowerCase();
    const filteredFormList = originalFormList.filter((item) => {
      let matches = false;
      if (item.medicalEmergencyId && String(item.medicalEmergencyId).toLowerCase().includes(lowerCaseValue)) {
        matches = true;
      }
      if (item.flightNo && item.flightNo.toLowerCase().includes(lowerCaseValue)) {
        matches = true;
      }
      return matches;
    });
    setRootFormDataList(filteredFormList);
    setCurrentPage(1); // Reset to the first page after search
  };

  const handlePageChange = (page) => {
    setCurrentPage(page);
    setRootFormDataList(
      originalFormList.slice((page - 1) * itemsPerPage, page * itemsPerPage)
    );
  };

  const startIndex = (currentPage - 1) * itemsPerPage;
  const endIndex = startIndex + itemsPerPage;

  const visibleFormDataList = rootFormDataList.slice(startIndex, endIndex);

  const showAddform = () => {
    setFittofly(true) // Redirect to the Add User page
  };


  return (
    <Box className="formList-container">
      {/* <Box className="form-header">
        <Box className="form-left-header"> */}
      {/* <Box className="form-search-modal">
            <TextInput
              className="form-search-input"
              onChange={(e) => onSearchStrChange(e.target.value)}
              placeholder="Search"
            />
            <img src={searchIcon} className="searchIcon" />
          </Box>
          <Button
            className="form-search-btn"
            label="Search"
            onClick={() => onSearch(searchString)}
          /> */}
      <Box style={{ width: '100%', display: 'flex', alignItems: 'end', marginBottom: '10px', marginRight: '2rem' }}>
        <CommonButton
          title="Add Forms"
          padding="12px 14px"
          color="#fff"
          bgColor="#357EFF"
          radius={10}
          border="1px solid #357EFF"
          lineheight="14px"
          width="10%"
          ml={5}
          onclick={showAddform}
          style={{
            position: "absolute",  // Position the button absolutely
            right: "20px",
          }}
        />

      </Box>


      {/* </Box>
      </Box> */}
      <Box style={{ display: "flex", flexDirection: "column", justifyContent: "space-between" }}>
        <Box
          className="form-table-container"
          style={{ height: visibleFormDataList.length > 0 ? "calc(100% - 48px)" : "auto" }}
        >
          <DataTable
            data={FormData} // Assuming formData holds the API response array
            resizeable
            className="form-datatable"
            paginate={true}
            step={itemsPerPage}
            columns={[
              {
                property: "id",
                header: <Text>ID</Text>,
                primary: true,
                render: (item) => <Text>{item.id}</Text>,
              },
              {
                property: "orgName",
                header: <Text>Organization</Text>,
                render: (item) => <Text>{item.orgId?.name || "N/A"}</Text>, // Display org name
              },
              {
                property: "time",
                header: <Text>Created At</Text>,
                render: (item) => <Text>{new Date(item.createdAt).toLocaleString()}</Text>, // Format timestamp
              },
              {
                property: "details",
                header: <Text>Details</Text>,
                render: (item) => (
                  <Box
                    direction="row"
                    style={{
                      display: "flex",
                      justifyContent: "center",
                      alignItems: "center",
                      gap: 12,
                    }}
                  >
                    <button
                      style={{cursor:"pointer"}}
                      className="details-btn"
                      onClick={() => showform(item.id)}
                    >
                      <img src={view} style={{ height: 11, width: 16 }} alt="View" />
                    </button>
                  </Box>
                ),
              },
            ]}
          />
        </Box>
        <Box className="form-pagination-container" style={{ position: "sticky", bottom: 0, backgroundColor: "white", zIndex: 1 }}>
          {rootFormDataList.length > itemsPerPage && (
            <Pagination
              currentPage={currentPage}
              totalPages={Math.ceil(rootFormDataList.length / itemsPerPage)}
              totalItems={rootFormDataList.length}
              onPageChange={handlePageChange}
              style={{ position: "sticky", bottom: 0, zIndex: 1, marginTop: "auto" }}
            />
          )}
        </Box>
      </Box>
      {Fittofly && (
        <Layer
          className="outer"
          full="vertical"
          position="right"
          onClickOutside={() => setFittofly(false)}
          onEsc={() => setFittofly(false)}
          style={{ borderRadius: "12px 0 0 12px", zIndex: 1000 }}
        >
          <Box className="create-user-container" style={{ maxWidth: "500px" }}>
            <Box className="add-user-modal">
              <h4>Add Forms</h4>
              <Button
                onClick={() => setFittofly(false)}
                style={{ position: "absolute", top: 20, right: 20 }}
              >
                <img
                  src={closeAddUserSidebar}
                  style={{ width: 20, height: 20 }}
                  alt="close"
                />
              </Button>
            </Box>

            <Box style={{ margin: "10px 0", marginBottom: "50px", width: "90%", marginLeft: "auto", marginRight: "auto" }}>
              <label
                htmlFor="organization"
                style={{
                  display: "block",
                  fontWeight: "600",
                  fontSize: "14px",
                  marginBottom: "5px",
                }}
              >
                Organization
              </label>
              <div style={{ width: "100%" }} className="add-user-sadmin">
                <Select
                  className="add-user-select select"
                  name="organization"
                  labelKey="label"
                  valueKey={{ key: "value", reduce: true }} // Add "reduce: true" here
                  options={filteredOptions.map((org) => ({
                    label: org.name,
                    value: org.id,
                  }))}
                  value={rootStore.adminStore.getSelectedOrgId}
                  placeholder="Select"
                  onChange={handleSelectChange}
                  onSearch={(text) => setSearchText(text)}

                />
              </div>
            </Box>

            <Box className="over-add-user" style={{ overflowY: "auto", maxHeight: "100vh", paddingBottom: "20px", scrollbarWidth: "none" }}>
              <Box className="add-user-modal-container" style={{ border: "none" }}>
                <Box className="add-user-modal-browserbox" style={{ marginBottom: "20px" }}>
                  <p>
                    <DocumentUpload size="18" color="#357EFF" />
                    Upload a PDF file
                  </p>
                  <label
                    htmlFor="fileInput"
                    style={{
                      cursor: "pointer",
                      color: "#357EFF",
                      textAlign: "center",
                      fontFamily: "Inter",
                      fontSize: "14px",
                      fontWeight: "600",
                    }}
                  >
                    Browse
                  </label>
                  <input
                    id="fileInput"
                    type="file"
                    accept=".pdf"
                    style={{ display: "none" }}
                    onChange={handlePdfUpload} // Handle file upload
                  />

                  {/* ✅ Display selected file name */}
                  {selectedFile && (
                    <p style={{ marginTop: "10px", fontSize: "14px", color: "#333" }}>
                      Selected file: <strong>{selectedFile}</strong>
                    </p>
                  )}
                </Box>;
              </Box>


              {/* Organization Dropdown */}


              {/* Dynamic Question Fields */}
              <Box style={{ margin: "10px 0", width: "90%", marginLeft: "auto", marginRight: "auto" }}>
                <div style={{ marginBottom: "30px", width: "100%", overflowY: "auto" }}>
                  {questions.map((question, index) => (
                    <Box key={question.id} style={{ marginBottom: "30px", width: "100%" }}>
                      <label
                        htmlFor={`question-${question.id}`}
                        style={{
                          display: "block",
                          fontWeight: "600",
                          fontSize: "14px",
                          marginBottom: "10px", // 10px margin below the label
                        }}
                      >
                        Screening Questions {question.id}
                      </label>
                      <Box direction="row" gap="small" align="center" style={{ width: "100%" }}>
                        <TextInput
                          id={`question-${question.id}`}
                          value={question.value}
                          onChange={(e) => handleQuestionChange(question.id, e.target.value)}
                          placeholder={`Enter Question ${question.id}`}
                          style={{
                            border: "1px solid #ccc",
                            borderRadius: "4px",
                            padding: "8px",
                            width: "100%",
                            boxSizing: "border-box",
                          }}
                        />
                        {question.id > 1 && ( // Only show the "Remove" button for questions after the first one
                          <FormTrash
                            color="red"
                            onClick={() => handleRemoveQuestion(question.id)}
                            style={{ cursor: "pointer" }}
                          />
                        )}
                        {index === questions.length - 1 && ( // Only show the "Add" button for the last question
                          <Button
                            icon={<span>+</span>}
                            onClick={handleAddQuestion}
                            size="small"
                            style={{
                              backgroundColor: "var(--primary-color)", // Use your primary color
                              color: "#fff",
                              fontSize: "22px",
                              borderRadius: "28px",
                              width: "20px",
                              height: "20px",
                              display: "Flex",
                              flexDirection: "column",
                              alignItems: "center",
                              justifyContent: "center"
                            }}
                          />
                        )}
                      </Box>
                    </Box>
                  ))}
                </div>
              </Box>
            </Box>

            <Box className="add-user-modal-btn" as="footer" style={{ marginTop: "20px", textAlign: "center" }}>
              <Button
                className="add-user-modal-btn-2"
                type="submit"
                primary
                label="Add"
                color="brand-1"
                onClick={handleSave}
              />
            </Box>
          </Box>
        </Layer>
      )}

      {showftfform && (
        <Layer
          className="outer"
          full="vertical"
          position="right"
          onClickOutside={() => setFittofly(false)}
          onEsc={() => setFittofly(false)}
          style={{ borderRadius: "12px 0 0 12px", zIndex: 1000 }}
        >
          <Box className="create-user-container" style={{ maxWidth: "500px" }}>
            <Box className="add-user-modal">
              <h4>View Form Details</h4>
              <Button
                onClick={() => setshowftfform(false)}
                style={{ position: "absolute", top: 20, right: 20 }}
              >
                <img
                  src={closeAddUserSidebar}
                  style={{ width: 20, height: 20 }}
                  alt="close"
                />
              </Button>
            </Box>

            {/* Organization Name (Read-Only) */}
            <Box
              style={{
                margin: "10px 0",
                marginBottom: "20px",
                width: "90%",
                marginLeft: "auto",
                marginRight: "auto",
              }}
            >
              <label
                htmlFor="organization"
                style={{
                  display: "block",
                  fontWeight: "600",
                  fontSize: "14px",
                  marginBottom: "5px",
                }}
              >
                Organization
              </label>
              <TextInput
                id="organization"
                value={ftfformview?.orgId?.name || "N/A"} // Display organization name
                readOnly
                style={{
                  border: "1px solid #ccc",
                  borderRadius: "4px",
                  padding: "8px",
                  width: "100%",
                  boxSizing: "border-box",
                  // backgroundColor: "#f5f5f5",
                  color: "#333",
                }}
              />
            </Box>

            {/* Form URL Field (Read-Only) */}
            <Box
              style={{
                margin: "10px 0",
                width: "90%",
                marginLeft: "auto",
                marginRight: "auto",
              }}
            >
              <label
                htmlFor="formUrl"
                style={{
                  display: "block",
                  fontWeight: "600",
                  fontSize: "14px",
                  marginBottom: "5px",
                }}
              >
                Form URL
              </label>
              <TextInput
                id="formUrl"
                value={ftfformview?.formUrl || "N/A"}
                readOnly
                style={{
                  border: "1px solid #ccc",
                  borderRadius: "4px",
                  padding: "8px",
                  width: "100%",
                  boxSizing: "border-box",
                  // backgroundColor: "#f5f5f5",
                  color: "#333",
                }}
              />
            </Box>

            {/* Screening Questions (Read-Only) */}
            <Box
              style={{
                margin: "10px 0",
                width: "90%",
                marginLeft: "auto",
                marginRight: "auto",
              }}
            >
              <div style={{ marginBottom: "30px", width: "100%", overflowY: "auto" }}>
                {ftfformview?.screeningQuestions?.map((question, index) => (
                  <Box key={question.id} style={{ marginBottom: "30px", width: "100%" }}>
                    <label
                      htmlFor={`question-${question.id}`}
                      style={{
                        display: "block",
                        fontWeight: "600",
                        fontSize: "14px",
                        marginBottom: "10px",
                      }}
                    >
                      Screening Question {index + 1}
                    </label>
                    <TextInput
                      id={`question-${question.id}`}
                      value={question.screeningQuestionText}
                      readOnly
                      style={{
                        border: "1px solid #ccc",
                        borderRadius: "4px",
                        padding: "8px",
                        width: "100%",
                        boxSizing: "border-box",
                        // backgroundColor: "#f5f5f5",
                        color: "#333",
                      }}
                    />
                  </Box>
                ))}
              </div>
            </Box>
          </Box>
        </Layer>
      )}


    </Box>
  );
});

export default fittofly;
